import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { EmptyState } from '@/components/ui/EmptyState';
import { Users } from 'lucide-react';

interface OrgMembersCardProps {
  org: any;
}

export function OrgMembersCard({ org }: OrgMembersCardProps) {
  const rawMembers = org.members || [];

  // API returns { uuid, role, joinedAt, user: { uuid, email, firstName, lastName } }
  const members = rawMembers.map((m: any) => ({
    uuid: m.uuid,
    role: m.role,
    joinedAt: m.joinedAt,
    email: m.user?.email || m.email || '',
    firstName: m.user?.firstName || m.firstName || '',
    lastName: m.user?.lastName || m.lastName || '',
  }));

  return (
    <Card>
      <CardHeader title="Membres" description={`${members.length} membre(s)`} />
      <CardContent>
        {members.length === 0 ? (
          <EmptyState message="Aucun membre" icon={<Users className="h-8 w-8" />} />
        ) : (
          <div className="space-y-2">
            {members.map((member: any) => (
              <div key={member.uuid} className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-3">
                <div>
                  <p className="text-sm text-neutral-700 dark:text-neutral-300">{member.firstName} {member.lastName}</p>
                  <p className="text-xs text-neutral-500">{member.email}</p>
                </div>
                <Badge variant={member.role === 'owner' ? 'warning' : 'info'}>{member.role}</Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
